import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RootExternalComponent } from './root-external.component';
import { CalculatorWrapComponent } from './calculators/calculator.component';
import { OptionsCalculatorWrapComponent } from './calculators/options-calculator.component';
import { ProbabilityCalculatorWrapComponent } from './calculators/probability-calculator.component';
import {
  PriceHistoricalImpliedVolatilityComponent
} from "@iv/shared/components/price-historical-implied-volatility/price-historical-implied-volatility.component";

const routes: Routes = [
  {
    path: 'external',
    component: RootExternalComponent,
    children: [
      {
        path: 'calculator',
        component: CalculatorWrapComponent
      },
      {
        path: 'calculators/options',
        component: OptionsCalculatorWrapComponent
      },
      {
        path: 'calculators/probability',
        component: ProbabilityCalculatorWrapComponent
      },
      {
        path: 'volatility-charts-tool',
        component: PriceHistoricalImpliedVolatilityComponent
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExternalRoutingModule {
}
